import React, { forwardRef, memo } from 'react'

const LockIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="29.4"
      height="29.4"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M33.7966 33.9798H7.75392C7.4404 33.9799 7.13769 33.8653 6.90276 33.6577C6.66784 33.4501 6.51692 33.1638 6.47841 32.8526L4.20641 13.72C4.18539 13.5404 4.20277 13.3585 4.25739 13.1862C4.31201 13.0139 4.40262 12.8552 4.52323 12.7206C4.64384 12.5859 4.79168 12.4785 4.95695 12.4053C5.12223 12.3321 5.30117 12.2949 5.48192 12.2962H36.0686C36.2494 12.2949 36.4283 12.3321 36.5936 12.4053C36.7589 12.4785 36.9067 12.5859 37.0273 12.7206C37.1479 12.8552 37.2386 13.0139 37.2932 13.1862C37.3478 13.3585 37.3652 13.5404 37.3442 13.72L35.0722 32.8526C35.0336 33.1638 34.8827 33.4501 34.6478 33.6577C34.4129 33.8653 34.1102 33.9799 33.7966 33.9798Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3977 17.3982V11.0206C14.3977 9.32919 15.0696 7.70703 16.2656 6.51101C17.4617 5.31498 19.0838 4.64307 20.7753 4.64307C22.4667 4.64307 24.0888 5.31498 25.2849 6.51101C26.4809 7.70703 27.1528 9.32919 27.1528 11.0206V17.3982"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

LockIcon.displayName = 'LockIcon'

export default memo(LockIcon)
